import { Shield } from "lucide-react";

export default function Independence() {
  return (
    <section
      id="independence"
      className="py-16 md:py-24 border-t-4 border-black bg-black text-white"
      data-testid="independence-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Shield size={48} strokeWidth={1.5} className="mx-auto mb-6 text-zinc-400" />
        
        <h2
          className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl uppercase mb-6"
          data-testid="independence-title"
        >
          Independent review, not another estimating platform.
        </h2>
        
        <p className="font-body text-zinc-300 text-lg leading-relaxed mb-8 max-w-3xl mx-auto">
          Blackline Tender Red Review does not replace your estimator. It acts as the final independent commercial safety gate before the number leaves your office. We assume the tender may contain errors and require material conclusions to be supported by the supplied evidence. Nothing is submitted, amended or communicated to the principal, client, supplier or subcontractor without your instruction. The final tender remains your decision.
        </p>

        <div className="border-t border-zinc-700 pt-8">
          <p className="font-mono text-xs text-zinc-500 uppercase tracking-wider leading-relaxed">
            Independent commercial review only. Not legal advice, engineering advice, a quantity surveyor's report or professional certification, a complete independent remeasurement, or a guarantee of tender success or project profitability.
          </p>
        </div>
      </div>
    </section>
  );
}
